import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ErrorBoundary } from "apps/commons/components/ErrorBoundary";
import { Provider as JotaiProvider } from "jotai";
import { usePerformanceMetric } from "libs/performances/usePerformanceMetric";
import type { FunctionComponent } from "react";
import { HelmetProvider } from "react-helmet";
import { Outlet } from "react-router";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
        },
    },
});

const Layout: FunctionComponent = () => {
    usePerformanceMetric();

    return (
        <HelmetProvider>
            <JotaiProvider>
                <QueryClientProvider client={queryClient}>
                    <ErrorBoundary>
                        <Outlet />
                    </ErrorBoundary>
                </QueryClientProvider>
            </JotaiProvider>
        </HelmetProvider>
    );
};

export default Layout;
